import React from "react";

function Card() {
  return (
    <div className="card-section">
      <div className="card-con">
        <div className="card" data-aos="fade-up" data-aos-duration="1000">
          <div className="cardh1"></div>
          <div>
            <br />
            <h3>hello world</h3>
            <br />
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Inventore
              totam nisi soluta consequatur, praesentium a! adipisicing elit.
              Inventore totam nisi
            </p>
            <br />
            <button>Learn More</button>
            <br />
            <br />
          </div>
        </div>
        <div className="card">
          <div className="cardh2"></div>
          <div>
            <br />
            <h3>hello world</h3>
            <br />
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Inventore
              totam nisi soluta consequatur, praesentium a! adipisicing elit.
              Inventore totam nisi
            </p>
            <br />
            <button>Learn More</button>
            <br />
            <br />
          </div>
        </div>
        <div className="card">
          <div className="cardh3"></div>
          <div>
            <br />
            <h3>hello world</h3>
            <br />
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Inventore
              totam nisi soluta consequatur, praesentium a! adipisicing elit.
              Inventore totam nisi
            </p>
            <br />
            <button>Learn More</button>
            <br />
            <br />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Card;
